import { h, FunctionComponent } from 'preact';
import { toKebabCase } from '~src/utils/helpers';
import LinkWrapper from './LinkWrapper';

type ButtonProps = {
  label: string;
  onClickPost: () => void;
  classLabel?: string;
  trackingLabel?: string;
  shouldTrackClick?: boolean;
  isDisabled?: boolean;
  trackClickPayload?: Object;
  id?: string;
};

const SimpleButton: FunctionComponent<ButtonProps> = props => {
  const {
    label,
    onClickPost,
    classLabel,
    trackingLabel,
    id,
    shouldTrackClick = true,
    isDisabled = false,
    trackClickPayload = {},
  } = props;

  return (
    <LinkWrapper
      id={id || toKebabCase(label)}
      testId='simple-button'
      disabled={isDisabled}
      classLabel={classLabel}
      onClickHandler={onClickPost}
      trackingConfig={
        shouldTrackClick && trackingLabel
          ? {
              label: trackingLabel,
              payload: trackClickPayload,
            }
          : undefined
      }
    >
      {label}
    </LinkWrapper>
  );
};
export default SimpleButton;
